import _ from "lodash";
import moment from "moment-timezone";
import { FunctionField } from "react-admin";

export const MyDateField = ({ source, ...props }) => {
  return (
    <FunctionField
      render={(record) => {
        var text = "";
        if (record) {
          var val = _.get(record, source);
          if (val) {
            var d = moment.tz(val, "Asia/Hong_Kong");

            if (props.showTimeWithSeconds) {
              text = d.format("YYYY-MM-DD HH:mm:ss");
            } else if (props.showTime) {
              text = d.format("YYYY-MM-DD HH:mm");
            } else {
              text = d.format("YYYY-MM-DD");
            }
          }
        }
        return text;
      }}
    />
  );
};

MyDateField.defaultProps = {
  addLabel: true,
};
